import React from "react";
import { connect } from "react-redux";
import "./Create_final.styles.scss";

const CreateFinal = ({ setPortfolioName, scenarioName }) => {
  return (
    <div className="create_final">
      <div className="create_final_head">
        <div className="create_final_head_img">
          <img src="/images/checklist.png" alt="iqcio list" />
        </div>
        <div className="create_final_head_content text-uppercase">
          <div className="create_final_head_content_head1">Almost done!</div>
          <div className="create_final_head_content_head2">
            We are all set to submit all the inputs provided so far to create a
            model portfolio
          </div>
        </div>
      </div>
      <div className="create_final_content">
        <p>
          Thank you for your time to provide all required inputs to create a
          model portfolio. Please provide a distinct name to your portfolio and
          click on the create button below (Create button will be enabled once
          you enter the portfolio name). This name will show up on the dashboard
          to uniquely identify the portfolio.
        </p>
        <div className="create_final_content_input">
          <div className="text-uppercase">Name your Portfolio : </div>
          <input
            type="text"
            placeholder=""
            defaultValue={scenarioName}
            className="create_final_content_input_portfolio"
            onChange={(e) => setPortfolioName(e.target.value)}
          />
        </div>
        <div className="create_final_content_note text-uppercase">
          Note : Once you click on the create portfolio, the backend process to
          create portfolio could take up to a minute or more to complete as our
          ai models are running and creating the portfolio model and
          recommendations. please be patient and do not click the back button.
        </div>
      </div>
    </div>
  );
};

export default connect(
  ({
    create: {
      steps: {
        risk: { scenarioName },
      },
    },
  }) => ({
    scenarioName,
  }),

  (dispatch) => ({
    setPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),
  })
)(CreateFinal);



// WEBPACK FOOTER //
// ./src/components/pages/Create/Create_final.jsx